<main
  class="relative flex h-full min-h-0 w-full flex-1 background"
>
  <section class="h-full" *ngIf="!fullscreen">
    <ng-content select="[menu]" />
  </section>

  <section class="flex flex-col flex-1 overflow-hidden min-w-0">
    <div
      #scrollContainer
      class="flex flex-col flex-1 overflow-y-auto relative"
    >
      @if (useBackground) {
        <img
          src="assets/svg/background-gradient.svg"
          alt=""
          class="absolute top-0 left-0 w-full h-[90vh] pointer-events-none object-cover"
        />
      }

      <ng-content select="[header]" />
      
      <div
        class="flex justify-center flex-1 flex-col"
        [ngClass]="fullscreen ? '' : 'px-3 pb-3 lg:px-10' "
      >
        <div [ngClass]="fullscreen ? 'w-full' : 'max-w-[1920px] w-full'">
          <ng-content select="router-outlet" />
        </div>
      </div>

      <!-- Footer -->
      @if (showFooter) {
        <l-footer class="block w-full" footer></l-footer>
      }
    </div>
  </section>
</main>
